import React from "react";
import { PasswordResetCompleteBody } from "tsi-common-react/src/apps/customer-account/PasswordResetCompleteBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetCompleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetCompleteBody {...props} />
    </PageSkeleton>
);
